import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex mb-4" }
const _hoisted_2 = { class: "d-none d-md-block mb-0" }
const _hoisted_3 = { class: "ms-auto" }
const _hoisted_4 = {
  key: 0,
  class: "w-100 mt-6"
}
const _hoisted_5 = { class: "fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "account_type",
  value: "personal",
  id: "kt_create_account_form_account_type_personal"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope fs-1 me-5" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, "Announcement"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-6" }, "sent via email")
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "account_type",
  value: "corporate",
  id: "kt_create_account_form_account_type_corporate"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sms fs-1 me-5" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, "Quick Message"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-6" }, "sent via text")
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "min-h-md-300px"
}
const _hoisted_19 = { class: "nav nav-tabs gap-4 gap-lg-10 gap-xl-15 mb-6 justify-content-between justify-content-md-start" }
const _hoisted_20 = {
  key: 0,
  class: "form"
}
const _hoisted_21 = {
  key: 1,
  class: "form"
}
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = {
  key: 2,
  class: "form"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " Attachments must be 5mb or less. Allowed types include: Images (jpg, jpeg, and png); Adobe Acrobat (pdf), Microsoft Word (doc, docx), and Music (mp3). ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-paperclip-vertical fa-4x" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Manage Communication",
    "has-footer": false,
    size: "modal-lg",
    "is-loading": _ctx.isLoading,
    "loading-text": _ctx.loadingText,
    ref: "modal"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.mode !== 'add')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _ctx.remove,
                class: "btn-sm btn-light btn-light-danger text-white me-4",
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Remove ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.mode === 'add' && _ctx.step === 2)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                type: "button",
                class: "btn btn-sm btn-secondary me-4",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save Draft ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.mode === 'update' && _ctx.step === 2 && _ctx.communication.status === 2)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                type: "button",
                class: "btn btn-sm btn-secondary me-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save Draft ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.mode === 'update' && _ctx.step === 2 && _ctx.communication.status === 1)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                type: "button",
                class: "btn btn-sm btn-primary me-4",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.mode === 'update' && _ctx.step === 2 && _ctx.communication.status === 2)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 4,
                type: "button",
                class: "btn btn-sm btn-primary me-4",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Publish ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.mode === 'add' && _ctx.step === 2)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 5,
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.add(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Save & Send ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.step === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("label", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setType(1))),
                    class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
                    for: "kt_create_account_form_account_type_personal"
                  }, _hoisted_11),
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("label", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setType(2))),
                    class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
                    for: "kt_create_account_form_account_type_corporate"
                  }, _hoisted_17)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("nav", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'general'}]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tab = 'general'))
              }, " General ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'people'}]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.tab = 'people'))
              }, " People & Groups ", 2),
              (_ctx.communication.type === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'attachments'}]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.tab = 'attachments'))
                  }, " Attachments ", 2))
                : _createCommentVNode("", true)
            ]),
            (_ctx.tab === 'general')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_ctx.communication.type === 1)
                    ? (_openBlock(), _createBlock(_component_InputGroup, {
                        key: 0,
                        label: "Name",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.communication.title.$error}]),
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.communication.title) = $event)),
                            placeholder: ""
                          }, null, 2), [
                            [_vModelText, _ctx.communication.title]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.communication.type === 2)
                    ? (_openBlock(), _createBlock(_component_InputGroup, {
                        key: 1,
                        label: "Text Message",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.communication.title.$error}]),
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.communication.title) = $event))
                          }, null, 2), [
                            [_vModelText, _ctx.communication.title]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.communication.type === 1)
                    ? (_openBlock(), _createBlock(_component_InputGroup, {
                        key: 2,
                        label: "Content",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_QuillEditor, {
                            theme: "snow",
                            content: _ctx.communication.content,
                            "onUpdate:content": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.communication.content) = $event)),
                            contentType: "html",
                            toolbar: _ctx.toolbar
                          }, null, 8, ["content", "toolbar"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tab === 'people')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_InputGroup, {
                      label: "People",
                      "is-required": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.communication.people,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.communication.people) = $event)),
                          options: _ctx.peopleOptions,
                          mode: "tags",
                          searchable: true,
                          trackBy: "label"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_InputGroup, {
                      label: "Groups",
                      "is-required": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.communication.groups,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.communication.groups) = $event)),
                          options: _ctx.groupsOptions,
                          mode: "tags",
                          searchable: true,
                          trackBy: "label"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tab === 'attachments')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_ctx.mode === 'update')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communication.attachments, (attachment) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mb-4",
                            key: attachment.communicationAttachmentId
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.getAttachmentLink(attachment.communicationAttachmentId)),
                                class: "text-hover-primary cursor-pointer fw-bold"
                              }, _toDisplayString(attachment.filename) + " (" + _toDisplayString(_ctx.convertToMB(attachment.size)) + ") ", 9, _hoisted_27),
                              _createElementVNode("div", {
                                class: "ms-auto text-white text-hover-danger cursor-pointer",
                                onClick: ($event: any) => (_ctx.removeAttachment(attachment.communicationAttachmentId))
                              }, [
                                _hoisted_29,
                                _createTextVNode(" remove ")
                              ], 8, _hoisted_28)
                            ])
                          ]))
                        }), 128)),
                        _createVNode(_component_el_upload, {
                          action: _ctx.uploadUrl,
                          "on-progress": _ctx.uploadProgress,
                          "on-success": _ctx.uploadSuccess,
                          "before-upload": _ctx.beforeUpload,
                          "show-file-list": _ctx.mode !== 'update',
                          "on-change": _ctx.onChange,
                          "on-remove": _ctx.onChange,
                          multiple: "",
                          "auto-upload": _ctx.mode === 'update',
                          ref: "uploadRef",
                          headers: _ctx.uploadHeaders
                        }, {
                          tip: _withCtx(() => [
                            _hoisted_30
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Button, { class: "btn-sm" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Select files to upload")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["action", "on-progress", "on-success", "before-upload", "show-file-list", "on-change", "on-remove", "auto-upload", "headers"])
                      ]))
                    : (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        description: "Please save your communication as a draft, in order to upload attachments."
                      }, {
                        image: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-loading", "loading-text"]))
}